/* assets/jb-customiser.js */
(function(){
  function init(){
    const modal = document.getElementById('jb-cust-modal');
    if(!modal) return;

    if(modal.dataset.jbInit === '1') return;
    modal.dataset.jbInit = '1';

    const pid = modal.getAttribute('data-jb-product-id');
    const cfg = (window.JB_CUSTOMISER_CONFIG && pid && window.JB_CUSTOMISER_CONFIG[String(pid)]) || null;
    if(!cfg || !Array.isArray(cfg.bottles) || !Array.isArray(cfg.lids)) return;

    const BOTTLES = cfg.bottles;
    const LIDS = cfg.lids;
    const SCROLL_TARGET = cfg.scrollTargetId || 'jb-quote';
    const BOUNDS = cfg.bounds || { left: 33, right: 66, top: 40, bottom: 90 };
    const REMOVEBG_PROXY_URL = modal.getAttribute('data-jb-removebg-proxy') || '';
    const REMOVEBG_API_KEY = modal.getAttribute('data-jb-removebg-key') || '';
    const ZAPIER_WEBHOOK_URL = modal.getAttribute('data-jb-zapier-webhook') || '';

    const openBtn = document.getElementById('jb-cust-open');
    const floatBtn = document.getElementById('jb-float-customise');

    function lockScroll(lock){
      document.documentElement.style.overflow = lock ? 'hidden' : '';
      document.body.style.overflow = lock ? 'hidden' : '';
    }

    let jbHeaderEl = null;
    let jbHeaderPrevZ = null;

    function findStickyHeaderWrapper(){
      const candidates = ['#shopify-section-header','.shopify-section--header','.shopify-section-group-header-group'];
      for (const sel of candidates){ const el = document.querySelector(sel); if(el) return el; }
      const header = document.querySelector('header, .header, [data-section-type="header"]');
      if(!header) return null;
      let el = header;
      while(el && el !== document.documentElement){
        const cs = window.getComputedStyle(el);
        if(cs.position === 'sticky' || cs.position === 'fixed') return el;
        el = el.parentElement;
      }
      const sections = Array.from(document.querySelectorAll('[id^="shopify-section-"]'));
      for (const s of sections){ const cs = window.getComputedStyle(s); if(cs.position === 'sticky' || cs.position === 'fixed') return s; }
      return null;
    }

    function lowerHeaderZIndex(){ jbHeaderEl = findStickyHeaderWrapper(); if(!jbHeaderEl) return; jbHeaderPrevZ = jbHeaderEl.style.zIndex; jbHeaderEl.style.zIndex = '0'; }
    function restoreHeaderZIndex(){ if(!jbHeaderEl) return; jbHeaderEl.style.zIndex = jbHeaderPrevZ || ''; jbHeaderEl = null; jbHeaderPrevZ = null; }

    function openModal(){ lowerHeaderZIndex(); modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); lockScroll(true); }
    function closeModal(){ modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); lockScroll(false); restoreHeaderZIndex(); }

    if(openBtn) openBtn.addEventListener('click', openModal);
    if(floatBtn){ floatBtn.addEventListener('click', (e) => { e.preventDefault(); openModal(); }); }

    modal.addEventListener('click', (e) => { if(e.target && e.target.hasAttribute('data-jb-close')) closeModal(); });
    window.addEventListener('keydown', (e) => { if(e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

// Floating button scroll trigger
(function(){
  var btn = document.querySelector('.jb-float-customise');
  var openBtn = document.getElementById('jb-cust-open');
  if(!btn) return;
  
  function isMobile(){
    return window.innerWidth <= 820;
  }
  
  function update(){
    // If main button exists, show floating button when main button is out of view
    if(openBtn){
      var rect = openBtn.getBoundingClientRect();
      var isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      if(isOutOfView){
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
      return;
    }
    
    // Fallback to percentage-based if no main button found
    var doc = document.documentElement;
    var scrollTop = window.pageYOffset || doc.scrollTop || 0;
    var scrollHeight = doc.scrollHeight || 0;
    var clientHeight = doc.clientHeight || window.innerHeight || 0;
    var maxScroll = Math.max(1, scrollHeight - clientHeight);
    var progress = scrollTop / maxScroll;
    
    // Different thresholds for mobile vs desktop
    var threshold = isMobile() ? 0.20 : 0.30;
    
    if(progress >= threshold){
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }
  
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();

    const stage = document.getElementById('jb-stage');
    const baseImg = document.getElementById('jb-base');
    const lidImg  = document.getElementById('jb-lid');
    const logoImg = document.getElementById('jb-logo');
    const laserEl = document.getElementById('jb-laser');
    const bottleGrid = document.getElementById('jb-bottle-grid');
    const lidGrid = document.getElementById('jb-lid-grid');
    const bottlePicked = document.getElementById('jb-bottle-picked');
    const lidPicked = document.getElementById('jb-lid-picked');
    const finishSelect = document.getElementById('jb-finish');
    const logoInput = document.getElementById('jb-logo-input');
    const removeBgCheckbox = document.getElementById('jb-remove-bg');
    const sizeRange = document.getElementById('jb-size');
    const rotateRange = document.getElementById('jb-rotate');
    const sizeVal = document.getElementById('jb-size-val');
    const rotateVal = document.getElementById('jb-rotate-val');
    const resetBtn = document.getElementById('jb-reset');
    const exportBtn = document.getElementById('jb-export');

    // Create boundary indicator
    let boundaryEl = document.getElementById('jb-boundary');
    if(!boundaryEl && stage){
      boundaryEl = document.createElement('div');
      boundaryEl.id = 'jb-boundary';
      boundaryEl.className = 'jb-cust__boundary';
      const boundaryLabel = document.createElement('div');
      boundaryLabel.className = 'jb-cust__boundaryLabel';
      boundaryLabel.textContent = 'Print area';
      boundaryEl.appendChild(boundaryLabel);
      stage.appendChild(boundaryEl);
      boundaryEl.style.left = BOUNDS.left + '%';
      boundaryEl.style.right = (100 - BOUNDS.right) + '%';
      boundaryEl.style.top = BOUNDS.top + '%';
      boundaryEl.style.bottom = (100 - BOUNDS.bottom) + '%';
    }

    // Create logo clip container - clips logo to print area
    let logoClipEl = document.getElementById('jb-logo-clip');
    if(!logoClipEl && stage && logoImg){
      logoClipEl = document.createElement('div');
      logoClipEl.id = 'jb-logo-clip';
      logoClipEl.className = 'jb-cust__logoClip';
      logoClipEl.style.left = BOUNDS.left + '%';
      logoClipEl.style.right = (100 - BOUNDS.right) + '%';
      logoClipEl.style.top = BOUNDS.top + '%';
      logoClipEl.style.bottom = (100 - BOUNDS.bottom) + '%';
      logoImg.parentNode.insertBefore(logoClipEl, logoImg);
      logoClipEl.appendChild(logoImg);
      if(laserEl) logoClipEl.appendChild(laserEl);
    }

    // Create drag hint (outside stage, below it)
    let dragHintEl = document.getElementById('jb-drag-hint');
    const stageWrap = document.querySelector('.jb-cust__stageWrap');
    if(!dragHintEl && stageWrap){
      dragHintEl = document.createElement('div');
      dragHintEl.id = 'jb-drag-hint';
      dragHintEl.className = 'jb-cust__dragHint';
      dragHintEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 9l-3 3 3 3"/><path d="M9 5l3-3 3 3"/><path d="M15 19l-3 3-3-3"/><path d="M19 9l3 3-3 3"/><path d="M2 12h20"/><path d="M12 2v20"/></svg><span>Drag to reposition</span>';
      stageWrap.appendChild(dragHintEl);
    }

// Create mini preview for mobile
let miniPreviewEl = document.getElementById('jb-mini-preview');
let miniCanvas = null;
let updateMiniPreview = function(){};
let checkStageVisibility = function(){};

if(!miniPreviewEl && stage){
  miniPreviewEl = document.createElement('div');
  miniPreviewEl.id = 'jb-mini-preview';
  miniPreviewEl.className = 'jb-cust__miniPreview';
  miniCanvas = document.createElement('canvas');
  miniCanvas.id = 'jb-mini-canvas';
  miniCanvas.width = 160;
  miniCanvas.height = 160;
  miniPreviewEl.appendChild(miniCanvas);
  modal.appendChild(miniPreviewEl);
  
// Update mini preview when stage changes
  updateMiniPreview = function(){
    if(!miniCanvas) return;
    const ctx = miniCanvas.getContext('2d');
    if(!ctx) return;
    ctx.clearRect(0, 0, 160, 160);
    if(baseImg.complete && baseImg.naturalWidth) ctx.drawImage(baseImg, 0, 0, 160, 160);
    if(lidImg.complete && lidImg.naturalWidth) ctx.drawImage(lidImg, 0, 0, 160, 160);
    if(state.hasLogo && logoImg.complete && logoImg.naturalWidth){
      // Get actual positions from the DOM
      const stageRect = stage.getBoundingClientRect();
      const logoRect = logoImg.getBoundingClientRect();
      
      // If stage is not visible, use fallback calculation
      if(stageRect.width === 0){
        const logoSize = 160 * 0.2;
        ctx.save();
        ctx.translate(80, 51);
        ctx.rotate(state.rotate * Math.PI / 180);
        ctx.drawImage(logoImg, -logoSize/2, -logoSize/2, logoSize, logoSize);
        ctx.restore();
        return;
      }
      
      // Calculate logo center relative to stage
      const logoCenterX = (logoRect.left + logoRect.width / 2) - stageRect.left;
      const logoCenterY = (logoRect.top + logoRect.height / 2) - stageRect.top;
      
      // Scale factor from stage to mini preview
      const scale = 160 / stageRect.width;
      
      // Apply to mini preview
      const miniX = logoCenterX * scale;
      const miniY = logoCenterY * scale;
      
      // Use state.size scaled to mini preview
      const logoSize = state.size * scale;
      
      // Get aspect ratio of logo to draw correctly
      const logoAspect = logoImg.naturalHeight / logoImg.naturalWidth;
      const logoW = logoSize;
      const logoH = logoSize * logoAspect;
      
      ctx.save();
      ctx.translate(miniX, miniY);
      ctx.rotate(state.rotate * Math.PI / 180);
      
      // For laser finish, create grayscale version
      if(state.finish === 'laser'){
        // Create temp canvas for grayscale conversion
        const tempCanvas = document.createElement('canvas');
        const tempW = Math.ceil(logoW);
        const tempH = Math.ceil(logoH);
        tempCanvas.width = tempW;
        tempCanvas.height = tempH;
        const tempCtx = tempCanvas.getContext('2d');
        
        // Draw logo to temp canvas
        tempCtx.drawImage(logoImg, 0, 0, tempW, tempH);
        
        // Get image data and convert to grayscale
        const imageData = tempCtx.getImageData(0, 0, tempW, tempH);
        const data = imageData.data;
        for(let i = 0; i < data.length; i += 4){
          const avg = (data[i] * 0.3 + data[i+1] * 0.59 + data[i+2] * 0.11);
          // Brighten and reduce contrast for metallic look
          const val = Math.min(255, avg * 1.1 + 30);
          data[i] = val;     // R
          data[i+1] = val;   // G
          data[i+2] = val;   // B
          // Keep alpha as is
        }
        tempCtx.putImageData(imageData, 0, 0);
        
        // Draw grayscale version
        ctx.drawImage(tempCanvas, -logoW/2, -logoH/2, logoW, logoH);
      } else {
        ctx.drawImage(logoImg, -logoW/2, -logoH/2, logoW, logoH);
      }
      
      ctx.restore();
    }
  };
  
  // Show/hide based on stage visibility
  checkStageVisibility = function(){
    if(!miniPreviewEl) return;
    if(!modal.classList.contains('is-open')){ 
      miniPreviewEl.classList.remove('is-visible'); 
      return; 
    }
    const rect = stage.getBoundingClientRect();
    // Show mini preview when bottom of stage is above viewport (scrolled out of view)
    const isHidden = rect.bottom < 0 || rect.top > window.innerHeight;
    if(isHidden){
      updateMiniPreview();
      miniPreviewEl.classList.add('is-visible');
    } else {
      miniPreviewEl.classList.remove('is-visible');
    }
  };
  
  // Listen for scroll on all possible scroll containers
  const modalBody = document.querySelector('.jb-cust-modal__body');
  if(modalBody){
    modalBody.addEventListener('scroll', checkStageVisibility, { passive: true });
  }
  
  // Also listen on the modal itself and window
  modal.addEventListener('scroll', checkStageVisibility, { passive: true });
  window.addEventListener('scroll', checkStageVisibility, { passive: true });
  window.addEventListener('resize', checkStageVisibility, { passive: true });
  
  // Check visibility periodically while modal is open (fallback)
  setInterval(function(){
    if(modal.classList.contains('is-open')){
      checkStageVisibility();
    }
  }, 300);
  
  // Update preview when images load
  baseImg.addEventListener('load', function(){ updateMiniPreview(); });
  lidImg.addEventListener('load', function(){ updateMiniPreview(); });
  logoImg.addEventListener('load', function(){ updateMiniPreview(); });
}
    // Create watermark
    let watermarkEl = document.getElementById('jb-watermark');
    if(!watermarkEl && stage){
      watermarkEl = document.createElement('div');
      watermarkEl.id = 'jb-watermark';
      watermarkEl.className = 'jb-cust__watermark';
      watermarkEl.textContent = 'Mockup by Just Bottle';
      stage.appendChild(watermarkEl);
    }

    // Create loading indicator
    let loadingEl = document.getElementById('jb-loading');
    if(!loadingEl && stage){
      loadingEl = document.createElement('div');
      loadingEl.id = 'jb-loading';
      loadingEl.className = 'jb-cust__loading';
      loadingEl.innerHTML = '<div class="jb-cust__spinner"></div><div class="jb-cust__loadingText">Processing logo...</div>';
      stage.appendChild(loadingEl);
    }

    function showLoading(msg){ if(loadingEl){ loadingEl.querySelector('.jb-cust__loadingText').textContent = msg || 'Processing...'; loadingEl.classList.add('is-visible'); } }
    function hideLoading(){ if(loadingEl) loadingEl.classList.remove('is-visible'); }

    const leadQtyEl = document.getElementById('jb-lead-qty');
    const qtyHelpEl = document.getElementById('jb-qty-help');
    let qtyTouched = false;
    const MOQ = cfg.moq || 25;
    const MULTIPLE = cfg.multiple || 25;

    function parseQty(v){ const cleaned = String(v || '').replace(/,/g,'').replace(/\s+/g,'').trim(); const n = Number(cleaned); return Number.isFinite(n) ? n : NaN; }
    function formatQty(n){ try { return Number(n).toLocaleString('en-US'); } catch(e){ return String(n); } }
    function nearestValidQty(n){ if(!Number.isFinite(n)) return null; const minN = Math.max(MOQ, n); const down = Math.floor(minN / MULTIPLE) * MULTIPLE; const up = down + MULTIPLE; const downSafe = Math.max(MOQ, down); return (minN - downSafe) < (up - minN) ? downSafe : up; }

    function qtyStatus(raw){
      const s = String(raw || '').trim();
      if(!s) return { ok:false, clean:'', msg:'MOQ ' + MOQ + '. Enter multiples of ' + MULTIPLE + '.' };
      const n = parseQty(s);
      if(!Number.isFinite(n)) return { ok:false, clean:'', msg:'Please enter a number (e.g. ' + MOQ + ', ' + (MOQ+MULTIPLE) + ', ' + formatQty(2500) + ').' };
      if(n < MOQ){ return { ok:false, clean:'', msg:'Minimum order is ' + MOQ + '.' }; }
      if(n % MULTIPLE !== 0){ const up = Math.ceil(n / MULTIPLE) * MULTIPLE; return { ok:false, clean:'', msg:'Please enter multiples of ' + MULTIPLE + '. Nearest: ' + formatQty(up) + '.' }; }
      return { ok:true, clean:String(n), msg:'OK (MOQ ' + MOQ + ', multiples of ' + MULTIPLE + ')' };
    }

    function markError(el, on){ if(!el) return; el.classList.toggle('jb-field-error', !!on); }

    function updateQtyUI(){
      if(!leadQtyEl) return true;
      const st = qtyStatus(leadQtyEl.value);
      if(qtyTouched){ markError(leadQtyEl, !st.ok); if(qtyHelpEl){ qtyHelpEl.textContent = st.msg || ''; qtyHelpEl.classList.toggle('is-error', !st.ok); } }
      else { markError(leadQtyEl, false); if(qtyHelpEl){ qtyHelpEl.textContent = ''; qtyHelpEl.classList.remove('is-error'); } }
      return st.ok;
    }

    if(leadQtyEl){
      leadQtyEl.addEventListener('input', () => { qtyTouched = true; updateQtyUI(); });
      leadQtyEl.addEventListener('blur', () => { qtyTouched = true; updateQtyUI(); });
      leadQtyEl.addEventListener('keypress', (e) => { const ch = e.key; if(ch.length === 1 && !/[0-9,\s]/.test(ch)) e.preventDefault(); });
    }

    // Clear error styling when user enters valid input
    function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim()); }
    
    const leadFirstEl = document.getElementById('jb-lead-first');
    const leadEmailEl = document.getElementById('jb-lead-email');
    const leadCurrencyEl = document.getElementById('jb-lead-currency');
    const leadCountryEl = document.getElementById('jb-lead-country');
    const leadTimelineEl = document.getElementById('jb-lead-timeline');
    

    if(leadFirstEl) leadFirstEl.addEventListener('input', () => { if(leadFirstEl.value.trim()) markError(leadFirstEl, false); });
    if(leadEmailEl) leadEmailEl.addEventListener('input', () => { if(validEmail(leadEmailEl.value)) markError(leadEmailEl, false); });
    if(leadCurrencyEl) leadCurrencyEl.addEventListener('change', () => { if(leadCurrencyEl.value) markError(leadCurrencyEl, false); });
    if(leadCountryEl) leadCountryEl.addEventListener('change', () => { if(leadCountryEl.value) markError(leadCountryEl, false); });
    if(leadTimelineEl) leadTimelineEl.addEventListener('change', () => { if(leadTimelineEl.value) markError(leadTimelineEl, false); });

    // Mobile slider relocation
    (function(){
      const sliders = document.querySelector('.jb-cust__sliders');
      const leftCol = document.querySelector('.jb-cust__left');
      if(!sliders || !leftCol) return;
      const placeholder = document.createElement('div');
      placeholder.setAttribute('data-jb-sliders-home', '1');
      sliders.parentNode.insertBefore(placeholder, sliders);
      function isMobile(){ return (window.innerWidth || document.documentElement.clientWidth || 9999) <= 820; }
      function relocate(){
        if(!modal.classList.contains('is-open')) return;
        if(isMobile()){ leftCol.appendChild(sliders); sliders.classList.add('jb-mobile-sliders'); }
        else { placeholder.insertAdjacentElement('afterend', sliders); sliders.classList.remove('jb-mobile-sliders'); }
      }
      function restore(){ placeholder.insertAdjacentElement('afterend', sliders); sliders.classList.remove('jb-mobile-sliders'); }
      const obs = new MutationObserver(() => { if(modal.classList.contains('is-open')) requestAnimationFrame(() => requestAnimationFrame(relocate)); else restore(); });
      obs.observe(modal, { attributes:true, attributeFilter:['class'] });
      window.addEventListener('resize', () => { if(modal.classList.contains('is-open')) requestAnimationFrame(relocate); }, { passive:true });
    })();

    if(!stage || !baseImg || !lidImg || !logoImg || !laserEl || !bottleGrid || !lidGrid || !finishSelect || !logoInput || !sizeRange || !rotateRange || !resetBtn || !exportBtn) return;

    // Scroll hint
    (function(){
      const panel = document.querySelector('.jb-cust__controlsTop');
      if(!panel) return;
      function updateHint(){ const canScroll = panel.scrollHeight > (panel.clientHeight + 2); const atBottom = (panel.scrollTop + panel.clientHeight) >= (panel.scrollHeight - 2); panel.classList.toggle('jb-can-scroll', canScroll && !atBottom); }
      updateHint();
      panel.addEventListener('scroll', updateHint, { passive:true });
      window.addEventListener('resize', updateHint);
      const obs = new MutationObserver(updateHint);
      obs.observe(modal, { attributes:true, attributeFilter:['class'] });
    })();

function setBase(i){ if(BOTTLES[i] && BOTTLES[i].url){ baseImg.src = BOTTLES[i].url; baseImg.onload = function(){ updateMiniPreview(); checkStageVisibility(); }; } }
function setLid(i){ if(LIDS[i] && LIDS[i].url){ lidImg.src = LIDS[i].url; lidImg.onload = function(){ updateMiniPreview(); checkStageVisibility(); }; } }

    const state = { 
      bottleIndex:0, lidIndex:0, dragging:false, startX:0, startY:0, x:0, y:0, 
      size:Number(sizeRange.value||140), rotate:Number(rotateRange.value||0), 
      finish:'print', hasLogo:false,
      originalLogoFile: null,
      originalLogoUrl: null
    };

    function showBoundary(){ if(boundaryEl) boundaryEl.classList.add('is-visible'); }
    function hideBoundary(){ if(boundaryEl) boundaryEl.classList.remove('is-visible'); }

    function setMode(){
      const laser = (state.finish === 'laser');
      if(!state.hasLogo){ 
        logoImg.style.display = 'none'; 
        laserEl.classList.remove('is-on'); 
        logoImg.classList.remove('is-off'); 
        if(dragHintEl) dragHintEl.classList.remove('is-visible');
        return; 
      }
      logoImg.style.display = 'block';
      if(dragHintEl) dragHintEl.classList.add('is-visible');
      if(laser){ logoImg.classList.add('is-off'); laserEl.classList.add('is-on'); }
      else { logoImg.classList.remove('is-off'); laserEl.classList.remove('is-on'); }
    }

    function applyTransform(){
      const t = 'translate(calc(-50% + ' + state.x + 'px), calc(-50% + ' + state.y + 'px)) rotate(' + state.rotate + 'deg)';
      logoImg.style.width = state.size + 'px';
      logoImg.style.maxWidth = 'none';
      logoImg.style.maxHeight = 'none';
      logoImg.style.transform = t;
      laserEl.style.width = state.size + 'px';
      laserEl.style.height = state.size + 'px';
      laserEl.style.transform = t;
      if(sizeVal) sizeVal.textContent = state.size + 'px';
      if(rotateVal) rotateVal.textContent = state.rotate + '°';
      setMode();
      if(typeof updateMiniPreview === 'function') updateMiniPreview();
    }

    function setActive(btns, idx){ btns.forEach((b, i) => b.classList.toggle('is-active', i === idx)); }

    function buildThumbGrid(items, mount, onPick){
      mount.innerHTML = '';
      const btns = [];
      items.forEach((item, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jb-cust__pick';
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('aria-label', item.label || 'Option ' + (i+1));
        const img = document.createElement('img');
        img.className = 'jb-cust__pickImg';
        img.alt = item.label || 'Option ' + (i+1);
        img.loading = 'lazy';
        img.src = item.url;
        const txt = document.createElement('div');
        txt.className = 'jb-cust__pickTxt';
        txt.textContent = item.label || 'Option ' + (i+1);
        btn.appendChild(img);
        btn.appendChild(txt);
        btn.addEventListener('click', () => { setActive(btns, i); onPick(i); });
        btns.push(btn);
        mount.appendChild(btn);
      });
      return btns;
    }

const bottleBtns = buildThumbGrid(BOTTLES, bottleGrid, (i) => { state.bottleIndex = i; setBase(i); if(bottlePicked) bottlePicked.textContent = BOTTLES[i] ? BOTTLES[i].label : ''; checkStageVisibility(); });
const lidBtns = buildThumbGrid(LIDS, lidGrid, (i) => { state.lidIndex = i; setLid(i); if(lidPicked) lidPicked.textContent = LIDS[i] ? LIDS[i].label : ''; checkStageVisibility(); });

    if(BOTTLES.length){ setBase(0); setActive(bottleBtns, 0); if(bottlePicked) bottlePicked.textContent = BOTTLES[0] ? BOTTLES[0].label : ''; }
    if(LIDS.length){ setLid(0); setActive(lidBtns, 0); if(lidPicked) lidPicked.textContent = LIDS[0] ? LIDS[0].label : ''; }

finishSelect.addEventListener('change', async (e) => {
  state.finish = (e.target.value === 'laser') ? 'laser' : 'print';
  
  if (state.finish === 'laser' && removeBgCheckbox && !removeBgCheckbox.checked && state.originalLogoFile && REMOVEBG_API_KEY) {
    const fileType = state.originalLogoFile.type;
    const fileName = state.originalLogoFile.name.toLowerCase();
    const isSvg = fileType === 'image/svg+xml' || fileName.endsWith('.svg');
    const isPdf = fileType === 'application/pdf' || fileName.endsWith('.pdf');
    
    if (!isSvg) {
      removeBgCheckbox.checked = true;
      showLoading(isPdf ? 'Processing PDF & removing background...' : 'Removing background for laser...');
      try {
        let fileToProcess = state.originalLogoFile;
        
        // If PDF, convert to PNG blob first
        if (isPdf) {
          const pngBlob = await convertPdfToPngBlob(state.originalLogoFile);
          fileToProcess = new File([pngBlob], 'converted.png', { type: 'image/png' });
        }
        
        const processedUrl = await removeBackground(fileToProcess);
        if (processedUrl) {
          logoImg.src = processedUrl;
          laserEl.style.setProperty('--jbLogoMask', 'url("' + processedUrl + '")');
          state.originalLogoUrl = processedUrl;
        }
      } catch (err) {
        console.warn('Background removal failed:', err);
        removeBgCheckbox.checked = false;
      } finally {
        hideLoading();
      }
    }
  }
  
  applyTransform();
});

async function removeBackground(file){
      if(!REMOVEBG_API_KEY){
        console.warn('Remove.bg API key not configured');
        return null;
      }

      var formData = new FormData();
      formData.append('image_file', file);
      formData.append('size', 'auto');
      formData.append('format', 'png');

      try {
        var res = await fetch('https://api.remove.bg/v1.0/removebg', {
          method: 'POST',
          headers: { 'X-Api-Key': REMOVEBG_API_KEY },
          body: formData
        });

        if(!res.ok){
          var errorData = await res.json().catch(function(){ return {}; });
          console.warn('Remove.bg error:', res.status, errorData);
          throw new Error(errorData.errors && errorData.errors[0] ? errorData.errors[0].title : 'Background removal failed (' + res.status + ')');
        }

        var blob = await res.blob();
        return URL.createObjectURL(blob);
      } catch(err){
        console.warn('Remove.bg failed:', err);
        throw err;
      }
    }

async function setLogo(file, shouldRemoveBg) {
  state.originalLogoFile = file;
  
  const fileType = file.type;
  const fileName = file.name.toLowerCase();
  const isPdf = fileType === 'application/pdf' || fileName.endsWith('.pdf');
  const isSvg = fileType === 'image/svg+xml' || fileName.endsWith('.svg');
  
  let previewUrl;
  
  // SVGs don't work with Remove.bg
  if (isSvg) {
    previewUrl = URL.createObjectURL(file);
    if (shouldRemoveBg && removeBgCheckbox) {
      removeBgCheckbox.checked = false;
    }
  } 
  // PDFs and images can go through Remove.bg
  else if (shouldRemoveBg && REMOVEBG_API_KEY) {
    showLoading(isPdf ? 'Processing PDF & removing background...' : 'Removing background...');
    try {
      let fileToProcess = file;
      
      // If PDF, convert to PNG blob first
      if (isPdf) {
        const pngBlob = await convertPdfToPngBlob(file);
        fileToProcess = new File([pngBlob], 'converted.png', { type: 'image/png' });
      }
      
      previewUrl = await removeBackground(fileToProcess);
    } catch (err) {
      console.warn('Background removal failed:', err);
      if (isPdf) {
        // Fallback to local PDF render
        try {
          previewUrl = await renderPdfToDataUrl(file);
        } catch (pdfErr) {
          hideLoading();
          alert('Failed to process PDF. Please try a different file.');
          return;
        }
      } else {
        previewUrl = URL.createObjectURL(file);
      }
      if (removeBgCheckbox) removeBgCheckbox.checked = false;
      alert('Background removal failed. Using original.');
    }
    hideLoading();
  } 
  // No background removal
  else {
    if (isPdf) {
      showLoading('Processing PDF...');
      try {
        previewUrl = await renderPdfToDataUrl(file);
      } catch (err) {
        hideLoading();
        alert('Failed to process PDF. Please try a different file.');
        return;
      }
      hideLoading();
    } else {
      previewUrl = URL.createObjectURL(file);
    }
  }
  
  state.originalLogoUrl = previewUrl;
  logoImg.src = previewUrl;
  laserEl.style.setProperty('--jbLogoMask', 'url("' + previewUrl + '")');
  state.hasLogo = true;
  state.x = 0;
  state.y = 0;
  applyTransform();
}

    logoInput.addEventListener('change', async () => {
      const file = logoInput.files && logoInput.files[0];
      if(!file) return;

      const shouldRemoveBg = removeBgCheckbox && removeBgCheckbox.checked;
      await setLogo(file, shouldRemoveBg);
    });

if (removeBgCheckbox) {
  removeBgCheckbox.addEventListener('change', async () => {
    if (!state.originalLogoFile) return;
    
    const fileType = state.originalLogoFile.type;
    const fileName = state.originalLogoFile.name.toLowerCase();
    const isPdf = fileType === 'application/pdf' || fileName.endsWith('.pdf');
    const isSvg = fileType === 'image/svg+xml' || fileName.endsWith('.svg');
    
    if (isSvg) {
      alert('Background removal is not available for SVG files.');
      removeBgCheckbox.checked = false;
      return;
    }
    
    if (removeBgCheckbox.checked) {
      showLoading(isPdf ? 'Processing PDF & removing background...' : 'Removing background...');
      try {
        let fileToProcess = state.originalLogoFile;
        
        // If PDF, convert to PNG blob first
        if (isPdf) {
          const pngBlob = await convertPdfToPngBlob(state.originalLogoFile);
          fileToProcess = new File([pngBlob], 'converted.png', { type: 'image/png' });
        }
        
        const processedUrl = await removeBackground(fileToProcess);
        if (processedUrl) {
          logoImg.src = processedUrl;
          laserEl.style.setProperty('--jbLogoMask', 'url("' + processedUrl + '")');
          state.originalLogoUrl = processedUrl;
        }
      } catch (err) {
        console.warn('Background removal failed:', err);
        alert('Background removal failed. Try a different file.');
        removeBgCheckbox.checked = false;
      } finally {
        hideLoading();
      }
    } else {
      // Restore original
      if (isPdf) {
        showLoading('Restoring original...');
        try {
          const originalUrl = await renderPdfToDataUrl(state.originalLogoFile);
          logoImg.src = originalUrl;
          laserEl.style.setProperty('--jbLogoMask', 'url("' + originalUrl + '")');
          state.originalLogoUrl = originalUrl;
        } catch (err) {
          console.warn('Failed to re-render PDF:', err);
        }
        hideLoading();
      } else {
        const originalUrl = URL.createObjectURL(state.originalLogoFile);
        logoImg.src = originalUrl;
        laserEl.style.setProperty('--jbLogoMask', 'url("' + originalUrl + '")');
        state.originalLogoUrl = originalUrl;
      }
    }
    applyTransform();
  });
}

    sizeRange.addEventListener('input', e => { state.size = Number(e.target.value); showBoundary(); applyTransform(); });
    sizeRange.addEventListener('change', () => { hideBoundary(); });
    rotateRange.addEventListener('input', e => { state.rotate = Number(e.target.value); applyTransform(); });

    function isPointerOnLogo(ev){
      if(!state.hasLogo) return false;
      const lrect = logoImg.getBoundingClientRect();
      const cx = (ev.touches ? ev.touches[0].clientX : ev.clientX);
      const cy = (ev.touches ? ev.touches[0].clientY : ev.clientY);
      return cx >= lrect.left && cx <= lrect.right && cy >= lrect.top && cy <= lrect.bottom;
    }

    // ✅ Check if event target is a form control (sliders, inputs, etc.)
    function isFormControl(el){
      if(!el) return false;
      const tag = el.tagName;
      if(tag === 'INPUT' || tag === 'SELECT' || tag === 'BUTTON' || tag === 'TEXTAREA' || tag === 'LABEL') return true;
      if(el.closest('.jb-cust__sliders') || el.closest('.jb-cust__controls')) return true;
      return false;
    }

    function down(ev){
      // ✅ Don't interfere with form controls (sliders, inputs, etc.)
      if(isFormControl(ev.target)) return;
      
      if(!isPointerOnLogo(ev)) return;
      state.dragging = true;
      state.startX = (ev.touches ? ev.touches[0].clientX : ev.clientX);
      state.startY = (ev.touches ? ev.touches[0].clientY : ev.clientY);
      if(dragHintEl) dragHintEl.classList.add('is-dragging');
      showBoundary();
      ev.preventDefault();
    }
    function move(ev){
      if(!state.dragging) return;
      const cx = (ev.touches ? ev.touches[0].clientX : ev.clientX);
      const cy = (ev.touches ? ev.touches[0].clientY : ev.clientY);
      state.x += (cx - state.startX);
      state.y += (cy - state.startY);
      state.startX = cx;
      state.startY = cy;
      applyTransform();
      ev.preventDefault();
    }
    function up(){ 
      state.dragging = false; 
      if(dragHintEl) dragHintEl.classList.remove('is-dragging');
      hideBoundary(); 
    }

    stage.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    stage.addEventListener('touchstart', down, { passive:false });
    window.addEventListener('touchmove', move, { passive:false });
    window.addEventListener('touchend', up);

    async function ensureHtml2Canvas(){
      if(window.html2canvas) return true;
      return new Promise((resolve) => {
        const s = document.createElement('script');
        s.src = "https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js";
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.head.appendChild(s);
      });
    }

    async function ensurePdfJs() {
  if (window.pdfjsLib) return true;
  return new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
    s.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
      resolve(true);
    };
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
}

async function convertPdfToPngBlob(file, maxSize = 800) {
  const ok = await ensurePdfJs();
  if (!ok) throw new Error('PDF.js failed to load');
  
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const page = await pdf.getPage(1);
  
  const viewport = page.getViewport({ scale: 1 });
  const scale = Math.min(maxSize / viewport.width, maxSize / viewport.height);
  const scaledViewport = page.getViewport({ scale });
  
  const canvas = document.createElement('canvas');
  canvas.width = scaledViewport.width;
  canvas.height = scaledViewport.height;
  const ctx = canvas.getContext('2d');
  
  await page.render({ canvasContext: ctx, viewport: scaledViewport }).promise;
  
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Failed to convert canvas to blob'));
    }, 'image/png');
  });
}

async function renderPdfToDataUrl(file, maxSize = 800) {
  const ok = await ensurePdfJs();
  if (!ok) throw new Error('PDF.js failed to load');
  
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const page = await pdf.getPage(1);
  
  const viewport = page.getViewport({ scale: 1 });
  const scale = Math.min(maxSize / viewport.width, maxSize / viewport.height);
  const scaledViewport = page.getViewport({ scale });
  
  const canvas = document.createElement('canvas');
  canvas.width = scaledViewport.width;
  canvas.height = scaledViewport.height;
  const ctx = canvas.getContext('2d');
  
  await page.render({ canvasContext: ctx, viewport: scaledViewport }).promise;
  
  return canvas.toDataURL('image/png');
}

    function downloadDataUrl(dataUrl, filename){ const a = document.createElement('a'); a.href = dataUrl; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); }
    function safeSlug(str){ return String(str || "").toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0, 60); }

    async function makeLaserPngDataUrlFromLogo(logoEl){
      if(!logoEl || !logoEl.src) return null;
      if(!(logoEl.complete && logoEl.naturalWidth > 0)){ await new Promise((resolve) => { logoEl.addEventListener('load', resolve, { once:true }); logoEl.addEventListener('error', resolve, { once:true }); }); }
      const w = Math.max(1, logoEl.naturalWidth);
      const h = Math.max(1, logoEl.naturalHeight);
      const maskC = document.createElement('canvas');
      maskC.width = w; maskC.height = h;
      const mctx = maskC.getContext('2d');
      if(!mctx) return null;
      mctx.clearRect(0, 0, w, h);
      mctx.drawImage(logoEl, 0, 0, w, h);
      const out = document.createElement('canvas');
      out.width = w; out.height = h;
      const ctx = out.getContext('2d');
      if(!ctx) return null;
      const baseGrad = ctx.createLinearGradient(0, 0, w, 0);
      baseGrad.addColorStop(0.00, '#ababab'); baseGrad.addColorStop(0.55, '#9b9b9b'); baseGrad.addColorStop(1.00, '#676767');
      ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = baseGrad; ctx.fillRect(0, 0, w, h);
      const band = ctx.createLinearGradient(0, 0, w, 0);
      band.addColorStop(0.00, 'rgba(212,212,212,0)'); band.addColorStop(0.38, 'rgba(212,212,212,0)'); band.addColorStop(0.50, 'rgba(212,212,212,0.80)'); band.addColorStop(0.62, 'rgba(212,212,212,0)'); band.addColorStop(1.00, 'rgba(212,212,212,0)');
      ctx.globalCompositeOperation = 'screen'; ctx.fillStyle = band; ctx.fillRect(0, 0, w, h); ctx.globalCompositeOperation = 'source-over';
      ctx.globalCompositeOperation = 'destination-in'; ctx.drawImage(maskC, 0, 0); ctx.globalCompositeOperation = 'source-over';
      return out.toDataURL('image/png');
    }

    // ✅ Send data to Zapier webhook
    async function sendToZapier(data) {
      if (!ZAPIER_WEBHOOK_URL) {
        console.warn('Zapier webhook URL not configured');
        return false;
      }

      try {
        const response = await fetch(ZAPIER_WEBHOOK_URL, {
          method: 'POST',
          mode: 'no-cors', // Zapier webhooks don't return CORS headers
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        });
        
        // With no-cors mode, we can't read the response, but if no error was thrown, it likely worked
        console.log('Zapier webhook sent successfully');
        return true;
      } catch (err) {
        console.error('Zapier webhook failed:', err);
        return false;
      }
    }

    exportBtn.addEventListener('click', async () => {
      const leadFirst = document.getElementById('jb-lead-first');
      const leadEmail = document.getElementById('jb-lead-email');
      const leadQty = document.getElementById('jb-lead-qty');
      const leadCurrency = document.getElementById('jb-lead-currency');
      const leadCountry = document.getElementById('jb-lead-country');
      const leadTimeline = document.getElementById('jb-lead-timeline');
      const leadComments = document.getElementById('jb-lead-comments');
      const redirectUrl = modal.getAttribute('data-jb-redirect') || '';
      const pageUrl = modal.getAttribute('data-jb-page-url') || window.location.href;
      const productTitle = modal.getAttribute('data-jb-product-title') || '';
      const productHandle = modal.getAttribute('data-jb-product-handle') || '';
      const detectedCurrency = modal.getAttribute('data-jb-currency') || '';
      const detectedCountry = modal.getAttribute('data-jb-country') || '';
      const uploadcareKey = modal.getAttribute('data-jb-uploadcare-public-key') || '';
      const uploadcareBaseUrl = modal.getAttribute('data-jb-uploadcare-base-url') || 'https://ucarecdn.com';

      try{ if(leadCurrency && !leadCurrency.value && detectedCurrency){ const opt = Array.from(leadCurrency.options).find(o => o.value === detectedCurrency); if(opt) leadCurrency.value = detectedCurrency; } if(leadCountry && !leadCountry.value && detectedCountry){ const opt = Array.from(leadCountry.options).find(o => o.value === detectedCountry); if(opt) leadCountry.value = detectedCountry; } }catch(e){}

      function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim()); }

      const firstVal = (leadFirst && leadFirst.value || '').trim();
      const emailVal = (leadEmail && leadEmail.value || '').trim();
      const qtyRaw = (leadQty && leadQty.value || '').trim();
      const qtyCheck = qtyStatus(qtyRaw);
      const qtyVal = qtyCheck.ok ? qtyCheck.clean : qtyRaw;
      const curVal = (leadCurrency && leadCurrency.value || '').trim();
      const countryVal = (leadCountry && leadCountry.value || '').trim();
      const timelineVal = (leadTimeline && leadTimeline.value || '').trim();
      const commentsVal = (leadComments && leadComments.value || '').trim();

      /* Mandatory logo upload commented out if(!state.hasLogo){ alert("Please upload a logo first."); return; } */

      let okForm = true;
      markError(leadFirst, !firstVal); if(!firstVal) okForm = false;
      markError(leadEmail, !validEmail(emailVal)); if(!validEmail(emailVal)) okForm = false;
      qtyTouched = true;
      const qtyOk = updateQtyUI();
      if(!qtyOk) okForm = false;
      markError(leadCurrency, !curVal); if(!curVal) okForm = false;
      markError(leadCountry, !countryVal); if(!countryVal) okForm = false;
      markError(leadTimeline, !timelineVal); if(!timelineVal) okForm = false;

      if(!okForm){ 
        // Scroll to first error field
        const firstErrorField = document.querySelector('.jb-field-error');
        if(firstErrorField){
          firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstErrorField.focus();
        }
        alert("Please complete all fields. Quantity must be at least 25 and in multiples of 25."); 
        return; 
      }

      const prevBtnHTML = exportBtn.innerHTML;
      exportBtn.disabled = true;
      exportBtn.style.opacity = '0.85';
      exportBtn.style.cursor = 'progress';
      function setBtnLabel(main, sub){ exportBtn.innerHTML = main + (sub ? '<span class="jb-cust__btnsub">' + sub + '</span>' : ''); }

      try{
        setBtnLabel('Generating preview…', 'Just a moment');
const ok = await ensureHtml2Canvas();
if(!ok) throw new Error("html2canvas failed to load");

// Scroll stage into view and wait for it to render (fixes mobile capture issue)
stage.scrollIntoView({ behavior: 'instant', block: 'center' });
await new Promise(r => setTimeout(r, 300));

// Force reload current bottle and lid images to ensure they're loaded
const currentBottleUrl = BOTTLES[state.bottleIndex] ? BOTTLES[state.bottleIndex].url : '';
const currentLidUrl = LIDS[state.lidIndex] ? LIDS[state.lidIndex].url : '';
if(currentBottleUrl && baseImg.src !== currentBottleUrl) baseImg.src = currentBottleUrl;
if(currentLidUrl && lidImg.src !== currentLidUrl) lidImg.src = currentLidUrl;

        const ensureLoaded = (imgEl) => new Promise((resolve) => { if(!imgEl || !imgEl.src) return resolve(true); if(imgEl.complete && imgEl.naturalWidth > 0) return resolve(true); const onDone = () => { cleanup(); resolve(true); }; const onErr = () => { cleanup(); resolve(false); }; const cleanup = () => { imgEl.removeEventListener('load', onDone); imgEl.removeEventListener('error', onErr); }; imgEl.addEventListener('load', onDone, { once:true }); imgEl.addEventListener('error', onErr, { once:true }); });
        await Promise.all([ensureLoaded(baseImg), ensureLoaded(lidImg), ensureLoaded(logoImg)]);

        const wasLaser = (state.finish === 'laser');
        const prevLaserDisplay = laserEl.style.display;
        const prevBaseDisplay = baseImg.style.display;
        const prevLidDisplay = lidImg.style.display;
        const prevLogoDisplay = logoImg.style.display;
        const prevLogoWasOff = logoImg.classList.contains('is-off');
        const prevBoundaryVisible = boundaryEl ? boundaryEl.classList.contains('is-visible') : false;

        if(boundaryEl) boundaryEl.classList.remove('is-visible');
        if(loadingEl) loadingEl.classList.remove('is-visible');
        laserEl.style.display = 'none';
        baseImg.style.display = 'block';
        lidImg.style.display = 'block';

        let exportLaserEl = null;

        if(state.hasLogo){
          if(wasLaser){
            logoImg.style.display = 'block';
            logoImg.classList.remove('is-off');
            const laserPngUrl = await makeLaserPngDataUrlFromLogo(logoImg);
            if(laserPngUrl){
              exportLaserEl = new Image();
              exportLaserEl.src = laserPngUrl;
              exportLaserEl.style.position = 'absolute';
              const logoCS = window.getComputedStyle(logoImg);
              exportLaserEl.style.left = logoCS.left;
              exportLaserEl.style.top = logoCS.top;
              exportLaserEl.style.transform = logoImg.style.transform || 'translate(-50%, -50%)';
              exportLaserEl.style.width = logoImg.style.width || (state.size + 'px');
              exportLaserEl.style.height = 'auto';
              exportLaserEl.style.zIndex = '4';
              exportLaserEl.style.pointerEvents = 'none';
              exportLaserEl.style.filter = 'drop-shadow(0.6px 0.8px 0 rgba(255,255,255,.20)) drop-shadow(-0.6px -0.8px 0 rgba(0,0,0,.18))';
              await new Promise((resolve) => { exportLaserEl.onload = resolve; exportLaserEl.onerror = resolve; });
              (logoClipEl || stage).appendChild(exportLaserEl);
            }
            logoImg.style.display = 'none';
          } else {
            logoImg.style.display = 'block';
            logoImg.classList.remove('is-off');
          }
        } else {
          logoImg.style.display = 'none';
          logoImg.classList.remove('is-off');
        }

        await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

        const canvas = await window.html2canvas(stage, {
          backgroundColor: null, scale: 2, useCORS: true, allowTaint: false,
          onclone: function(clonedDoc, element) {
            const scripts = element.querySelectorAll('script'); scripts.forEach(s => s.remove());
            const clonedBoundary = element.querySelector('.jb-cust__boundary'); if(clonedBoundary) clonedBoundary.remove();
            const clonedLoading = element.querySelector('.jb-cust__loading'); if(clonedLoading) clonedLoading.remove();
          }
        });

        if(exportLaserEl && exportLaserEl.parentNode) exportLaserEl.parentNode.removeChild(exportLaserEl);

        laserEl.style.display = prevLaserDisplay;
        baseImg.style.display = prevBaseDisplay;
        lidImg.style.display = prevLidDisplay;
        logoImg.style.display = prevLogoDisplay;
        if(prevLogoWasOff) logoImg.classList.add('is-off'); else logoImg.classList.remove('is-off');
        if(boundaryEl && prevBoundaryVisible) boundaryEl.classList.add('is-visible');
        applyTransform();

        const dataUrl = canvas.toDataURL("image/png");
        const bottleName = safeSlug(BOTTLES[state.bottleIndex] ? BOTTLES[state.bottleIndex].label : "bottle");
        const lidName = safeSlug(LIDS[state.lidIndex] ? LIDS[state.lidIndex].label : "lid");
        const finishName = wasLaser ? "laser" : "print";
        const filename = 'JustBottle-' + bottleName + '-' + lidName + '-' + finishName + '.png';

        setBtnLabel('Uploading preview…', 'Securing your image');
        if(!uploadcareKey || String(uploadcareKey).indexOf('PASTE_') === 0) throw new Error("Uploadcare public key missing");

        function dataUrlToBlob(d){ const parts = String(d).split(','); const mimeMatch = parts[0].match(/:(.*?);/); const mime = (mimeMatch && mimeMatch[1]) || 'image/png'; const bin = atob(parts[1]); const len = bin.length; const arr = new Uint8Array(len); for(let i=0;i<len;i++) arr[i] = bin.charCodeAt(i); return new Blob([arr], { type: mime }); }

        async function uploadToUploadcare(blob, publicKey, baseUrl, customFilename){
          const fd = new FormData();
          fd.append('UPLOADCARE_PUB_KEY', publicKey);
          fd.append('UPLOADCARE_STORE', '1');
          fd.append('file', blob, customFilename || filename);
          const res = await fetch('https://upload.uploadcare.com/base/', { method: 'POST', body: fd });
          if(!res.ok) throw new Error('Upload failed');
          const json = await res.json();
          if(!json || !json.file) throw new Error('Upload returned no file id');
          const cleanBase = String(baseUrl || 'https://ucarecdn.com').replace(/\/+$/,'');
          return cleanBase + '/' + json.file + '/';
        }

        const blob = dataUrlToBlob(dataUrl);
const hostedUrl = await uploadToUploadcare(blob, uploadcareKey, uploadcareBaseUrl);

// Upload the original logo file to Uploadcare
setBtnLabel('Uploading logo…', 'Saving your artwork');
let originalLogoUrl = '';
if(state.originalLogoFile){
  try {
    const logoFilename = state.originalLogoFile.name || 'logo.png';
    originalLogoUrl = await uploadToUploadcare(state.originalLogoFile, uploadcareKey, uploadcareBaseUrl, logoFilename);
  } catch(err){
    console.warn('Failed to upload original logo:', err);
    // Continue anyway - we still have the preview
  }
}

setBtnLabel('Sending enquiry…', 'Almost done');

        const bottleLabel = (BOTTLES[state.bottleIndex] ? BOTTLES[state.bottleIndex].label : '');
        const lidLabel = (LIDS[state.lidIndex] ? LIDS[state.lidIndex].label : '');
        const finishLabel = wasLaser ? 'Laser engraved' : 'Colour print';

        // ✅ Send to Zapier webhook instead of Shopify contact form
        const zapierData = {
          // Lead info
          first_name: firstVal,
          email: emailVal,
          quantity: qtyVal,
          currency: curVal,
          delivery_country: countryVal,
          timeline: timelineVal,
          comments: commentsVal,

          
          // Product info
          product_title: productTitle,
          product_handle: productHandle,
          page_url: pageUrl,
          
          // Customisation details
          bottle_colour: bottleLabel,
          lid_colour: lidLabel,
          finish: finishLabel,
          
          // Preview
          preview_url: hostedUrl,
filename: filename,

// Original logo file
original_logo_url: originalLogoUrl,
original_logo_filename: state.originalLogoFile ? (state.originalLogoFile.name || 'logo.png') : '',
          
          // Logo positioning
          logo_position_x: state.x,
          logo_position_y: state.y,
          logo_size: state.size + 'px',
          logo_rotation: state.rotate + '°',
          
          // Metadata
          detected_country: detectedCountry,
          detected_currency: detectedCurrency,
          browser_language: navigator.language || '',
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
          user_agent: navigator.userAgent || '',
          submitted_at: new Date().toISOString()
        };

        await sendToZapier(zapierData);

        // OpenAI Ads conversion
        if (typeof oaiq === 'function') {
          oaiq(
           "measure",
           "lead_created",
           { type: "customer_action" }
          );
        }

        
        // Trigger download
        setBtnLabel('Done — downloading…', 'Starting download');
        downloadDataUrl(dataUrl, filename);

        // On mobile, delay redirect to give download time to start
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth <= 820;
        
        setBtnLabel('Done — continuing…', 'Redirecting');
        closeModal();
        
        if (redirectUrl) {
          if (isMobile) {
            // Delay redirect on mobile so download can initiate
            setTimeout(() => {
              window.location.href = redirectUrl;
            }, 1500);
          } else {
            window.location.href = redirectUrl;
          }
        }

      } catch(err){
        console.warn(err);
        alert("Something went wrong sending your enquiry.\n\nIf the preview downloaded, you can still contact us — otherwise please try again.");
      } finally {
        exportBtn.disabled = false;
        exportBtn.style.opacity = '';
        exportBtn.style.cursor = '';
        exportBtn.innerHTML = prevBtnHTML;
      }
    });

    resetBtn.addEventListener('click', () => {
      state.bottleIndex = 0; state.lidIndex = 0;
      if(BOTTLES.length){ setBase(0); setActive(bottleBtns, 0); if(bottlePicked) bottlePicked.textContent = BOTTLES[0] ? BOTTLES[0].label : ''; }
      if(LIDS.length){ setLid(0); setActive(lidBtns, 0); if(lidPicked) lidPicked.textContent = LIDS[0] ? LIDS[0].label : ''; }
      finishSelect.value = "print";
      state.finish = "print";
      logoInput.value = "";
      logoImg.src = "";
      logoImg.style.display = "none";
      laserEl.style.removeProperty('--jbLogoMask');
      laserEl.classList.remove('is-on');
      logoImg.classList.remove('is-off');
      state.hasLogo = false;
      state.originalLogoFile = null;
      state.originalLogoUrl = null;
      if(removeBgCheckbox) removeBgCheckbox.checked = false;
      state.x = 0; state.y = 0;
      state.size = 140; state.rotate = 0;
      sizeRange.value = "140"; rotateRange.value = "0";
      qtyTouched = false;
      if(leadQtyEl) leadQtyEl.value = '';
      updateQtyUI();
      hideBoundary();
      hideLoading();
      applyTransform();
    });

    applyTransform();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();